import EventEmitter from "events";
import { CustomEase, TimelineLite, TimelineMax, TweenLite } from "gsap/all";
export default class Result extends EventEmitter {
    constructor() {
        super();
        this.classes = {
            open: ".js-menu-open",
            close: ".js-menu-close",
            shareBtn: ".js-share",
            share: ".js-share-btn",
            menu: ".js-menu",
            levelUpBtn: ".js-level-up",
            resultsControls: ".result__controls__wrapper",
            restart: '.js-restart',
        };
        this.activeClasses = {
            blurred: "is-blurred",
            opened: "is-menu-opened",
            answersShown: "is-answers-shown",
            linksShown: "is-links-shown",
        };
        this.results = null;
        this.particles = null;
        this.phase = null;
        this.body = document.body;
        this.menu = document.querySelector(this.classes.menu);
        this.container = document.querySelector(".js-result");
        this.resultEls = Array.from(document.querySelectorAll(".js-result-percentage"));
        this.animatedItems = Array.from(document.querySelectorAll(".js-result .js-animate-block"));
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.restart = this.restart.bind(this);
        this.openEls = Array.from(document.querySelectorAll(this.classes.open));
        this.closeEls = Array.from(document.querySelectorAll(this.classes.close));
        this.restartEl = document.querySelector(this.classes.restart);
    }
    setValues({ results, phase, particles }) {
        this.results = results;
        this.phase = phase;
        this.particles = particles;
        // TweenLite.set(this.particles.webgl.camera.position, { z: 300 });
        this.init();
    }
    restart() {
        this.close();
        window.analytics.trackAction('click_again');
        this.value = '0';
        this.container.dataset.first = this.value;
        this.container.dataset.second = this.value;
        this.insertResult();
        TweenLite.set('#particles', { autoAlpha: 1 });
        TweenLite.set([
            this.animatedItems,
            ".js-result .js-animate-block",
            ".js-percentage-block",
        ], { autoAlpha: 0 });
        this.emit("onRestart");
    }
    close() {
        const menu = document.querySelector(this.classes.menu);
        this.body.classList.remove(this.activeClasses.opened);
        if (menu) {
            menu.classList.remove(this.activeClasses.answersShown);
            menu.classList.remove(this.activeClasses.linksShown);
        }
    }
    open(event) {
        const menu = document.querySelector(this.classes.menu);
        if (this.tl) {
            this.tl.pause();
        }
        TweenLite.set(['.js-menu-close', '.js-menu-answers-block', '.js-menu-answers button', '.js-restart'], { autoAlpha: 0, y: -30 });
        // @ts-ignore
        if (Array.from(event.target.classList).includes(this.classes.levelUpBtn.slice(1))) {
            menu.classList.remove(this.activeClasses.answersShown);
            menu.classList.add(this.activeClasses.linksShown);
            window.analytics.trackAction('click_improve');
            this.tl = new TimelineMax()
                .staggerTo(['.js-menu-close', '.js-menu-answers-block', '.js-menu-answers button'], 0.5, { autoAlpha: 1, y: 0 }, 0.3);
        }
        else {
            menu.classList.add(this.activeClasses.answersShown);
            menu.classList.remove(this.activeClasses.linksShown);
            window.analytics.trackAction('click_check');
            this.tl = new TimelineMax()
                .staggerTo(['.js-answer .js-menu-answers-block', '.js-restart', '.js-menu-close'], 0.5, { autoAlpha: 1, y: 0 }, 0.3);
        }
        this.body.classList.add(this.activeClasses.opened);
    }
    getResult() {
        return this.value;
    }
    insertResult() {
        this.resultEls.forEach((item) => {
            const el = item;
            el.innerHTML = this.value;
        });
    }
    setResult(value) {
        this.value = value;
        const btn = document.querySelector(this.classes.share);
        btn.dataset.result = value;
    }
    calcResult() {
        const resultsArr = Object.values(this.results);
        const middleValue = Number((resultsArr.reduce((res, item) => res + Number(item), 0) /
            resultsArr.length).toFixed());
        let value = middleValue === 100 ? 99 : middleValue;
        value = value === 0 ? 1 : value;
        const levelUpBtn = document.querySelector(this.classes.levelUpBtn);
        if (value <= 24) {
            this.container.dataset.percentage = "24";
        }
        else if (value <= 49) {
            this.container.dataset.percentage = "49";
        }
        else if (value <= 74) {
            this.container.dataset.percentage = "74";
        }
        else if (value <= 98) {
            this.container.dataset.percentage = "98";
        }
        else {
            this.container.dataset.percentage = "99";
        }
        const [a, b] = value.toString().split('');
        if (b) {
            this.container.dataset.first = a;
            this.container.dataset.second = b;
        }
        else {
            this.container.dataset.first = '0';
            this.container.dataset.second = a;
        }
        if (value === 99) {
            levelUpBtn.classList.add("hidden");
        }
        else {
            levelUpBtn.classList.remove("hidden");
        }
        this.setResult(value.toString());
    }
    initHandlers() {
        if (this.isHandlersInited) {
            return;
        }
        this.isHandlersInited = true;
        this.openEls.forEach((item) => item.addEventListener("click", this.open));
        this.closeEls.forEach((item) => item.addEventListener("click", this.close));
        this.restartEl.addEventListener("click", this.restart);
    }
    finalAnimation({ scale, random, curl }) {
        window.analytics.trackAction('screen_8_outro');
        const video = document.querySelector('.js-floating-points-video');
        video.currentTime = 0;
        const duration = 3;
        const duration1 = duration * 1.2;
        // .fromTo(this.object3D.material.uniforms.uSizeScale0, 6, { value: 0 }, { value: 4, ease: 'sine.in' }, '-=6')
        // .fromTo(this.object3D.material.uniforms.uSizeScale1, 10, { value: 0 }, { value: 6, ease: 'sine.in' }, '-=10')
        // .fromTo(this.object3D.material.uniforms.uSizeScale2, 10, { value: 0 }, { value: 8, ease: 'sine.in' }, '-=10')
        const ease = CustomEase.create("custom", "M0,0 C0,0 0.562,-0.044 0.76,0.028 0.967,0.103 1,1 1,1 ");
        const tl = new TimelineLite({
            paused: true,
        })
            .to(this.particles.webgl.particles.object3D.material.uniforms.uRandom, duration1, { value: random - 3, ease: 'Quad.easeIn' })
            .to(this.particles.webgl.particles.object3D.material.uniforms.uCurl, duration1, { value: curl - 0.4, ease: 'Quad.easeIn' }, `-=${duration1}`)
            .to(this.particles.webgl.particles.object3D.material.uniforms.uRandom, duration1, { value: random, ease: 'Quad.easeIn' })
            .to(this.particles.webgl.particles.object3D.material.uniforms.uCurl, duration1, { value: curl, ease: 'Quad.easeIn' }, `-=${duration1}`)
            .to(this.particles.webgl.particles.object3D.material.uniforms.finalColor, duration, { value: 0, ease: 'Quad.easeIn' }, `-=${duration * 0.7}`)
            .fromTo([
            this.particles.webgl.particles.object3D.material.uniforms.uSizeScale,
            this.particles.webgl.particles.object3D.material.uniforms.uSizeScale0
        ], duration, { value: 1 }, { value: 420, ease }, `-=${duration * 0.8}`)
            .to(this.particles.webgl.particles.object3D.material.uniforms.scale, duration, {
            value: scale + 1.4,
            onStart: () => {
                video.onplay = () => {
                    new TimelineLite()
                        .to('.js-floating-points-video-wrap', 1, {
                        autoAlpha: 1,
                        onStart: () => {
                            new TimelineLite()
                                .to('#particles', 0.5, { autoAlpha: 0 }, '+=0.5')
                                .to('.js-floating-points-video-wrap', 0.5, {
                                autoAlpha: 0,
                                onStart: () => {
                                    this.calcResult();
                                    this.insertResult();
                                    this.body.classList.add(this.activeClasses.blurred);
                                },
                                onComplete: () => {
                                    window.analytics.trackAction('screen_9_results');
                                    window.analytics.trackAction(`stats_res_${this.getResult()}`);
                                }
                            }, '+=3')
                                .fromTo('.js-percentage-block', 0.6, { autoAlpha: 0 }, { autoAlpha: 1 }, '+=0.5')
                                .fromTo('.js-percentage-block > .result__percentage > div:first-child', 0.6, { autoAlpha: 0, x: -130, y: -50 }, { autoAlpha: 1, x: 0, y: 0 }, '-=0.6')
                                .fromTo('.js-percentage-block > .result__percentage > div:last-child', 0.6, { autoAlpha: 0, x: 130, y: -50 }, { autoAlpha: 1, x: 0, y: 0 }, '-=0.6')
                                .staggerFromTo(this.animatedItems, 0.3, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0 }, 0.2);
                        },
                    });
                };
                video.play();
            }
        }, `-=${duration * 0.2}`);
        tl.play();
    }
    init() {
        this.initHandlers();
    }
}
